const Dashboards = (props) => {
    return(
        <div {...props}>Dashboards</div>
    )
}

export default Dashboards